const PageCompanyInfo = () => import('@/modules/message/company/PageCompanyInfo')
const companyQuery = () => import('@/modules/message/company/companyQuery')
const PageTagInfo = () => import('@/modules/message/tagInfo/PageTagInfo')
const PageCollectInfo = () => import('@/modules/message/collect/PageCollectInfo')
const PageAuditorCompany = () => import('@/modules/message/company/PageAuditorCompany')
const PagePropertyConfig = () => import('@/modules/message/history/PagePropertyConfig')
export default [
  {
    path: '/zcfw/companyInfo',
    name: 'companyInfo',
    component: PageCompanyInfo,
    meta: {
      title: '我要成为企业',
      isBlack: true
    },
  },
  {
    path: '/zcfw/collectInfo',
    name: 'collectInfo',
    component: PageCollectInfo,
    meta: {
      title: '我的收藏',
    },
  },
  {
    path: '/zcfw/tagInfo',
    name: 'tagInfo',
    component: PageTagInfo,
    meta: {
      title: '我的标签',
    },
  },
  {
    path: '/zcfw/auditorCompany',
    name: 'auditorCompany',
    component: PageAuditorCompany,
    meta: {
      title: '审核企业',
    },
  }, {
    path: '/companyQuery',
    name: 'companyQuery',
    component: companyQuery,
    meta: {
      title: '企业查询',
      isBlack: true
    },
  },
  {
    path: '/company/properties',
    name: 'PagePropertyConfig',
    component: PagePropertyConfig,
    meta: {
      title: '企业字段维度查询',
      isBlack: true
    },
  }
]
